import React, {Fragment} from 'react'
import JLabel from '../Layout/JLabel';

const TestingPage = () => {
    return <Fragment>
        <JLabel>Testing Page!</JLabel>
    </Fragment>
}

export default TestingPage;